import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsPR: CultureInfo = {
  name: 'es-PR',
  displayName: 'Spanish (Puerto Rico)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-PR',
  parent: CultureInfoEs
};
